import { DateTime } from 'luxon';

import { JOB_TYPES, REPEAT_CYCLE } from '../../../../../types';
import {
    CreateJobAdditionalInformation,
    CreateJobContact,
    CreateJobEventInformation,
    CreateJobGuards,
    CreateJobOngoingDetails,
    CreateJobUniform,
    Job,
    JobDate
} from '../CreateJob/create-job.model';

// Sample data for a CreateJob instance, useful for tests and review screen
const jobDate = DateTime.local().plus({ days: 5 });
// Sample data for a CreateJob instance, useful for tests and review screen
export const sampleCreateJob = new Job(
    JOB_TYPES.ONGOING, // type
    new JobDate(
        jobDate // startDate
    ),
    new CreateJobGuards(
        2, // guardsCount
        8 // hoursGuardPerDay
    ),
    new CreateJobContact('John Doe', '+1234567890', 'john.doe@example.com'),
    new CreateJobEventInformation(
        { id: 1, label: 'Corporate Event', value: 'corporate-event' }, // eventType
        {
            street_number: '123',
            street: '123 Main St',
            city: 'Metropolis',
            state: 'CA',
            zip: '90001',
            formattedAddress: '123 Main St, Metropolis, CA 90001'
        }
    ),
    new CreateJobAdditionalInformation(
        'Job details text',
        'None', // previousIssues
        'Call 911 in emergency', // emergencyProcedures
        'Monitor entrances and exits' // guardPrimaryDuties
    ),
    new CreateJobUniform('Standard Security', 'Client'),
    new CreateJobOngoingDetails(
        jobDate.plus({ day: 2 }).plus({ hour: 8 }),
        REPEAT_CYCLE.WEEKLY, // repeatCycle
        '', // repeatCycleCustomType
        0, // repeatCycleFrequencyAmount
        [], // repeatDays
        jobDate.plus({ days: 30 })
    )
);
